module.exports = __webpack_public_path__ + "media/outro.9cedf620.mp4";